import api from "../plugins/apiWrapper";

export default {
  async fetchPriceInFiat() {
    return api.get("/coingecko");
  },
};
